function openInNewTab(url) {
  window.open(url, "_blank").focus();
}

export { openInNewTab };
